var User = /** @class */ (function () {
    function User() {
        this.userCredential = {};
    }
    return User;
}());
export { User };
var UserCredential = /** @class */ (function () {
    function UserCredential() {
    }
    return UserCredential;
}());
export { UserCredential };
var CountryTO = /** @class */ (function () {
    function CountryTO() {
    }
    return CountryTO;
}());
export { CountryTO };
var UserAddress = /** @class */ (function () {
    function UserAddress() {
        this.countryTO = {};
    }
    return UserAddress;
}());
export { UserAddress };
var UserSubType = /** @class */ (function () {
    function UserSubType() {
    }
    return UserSubType;
}());
export { UserSubType };
var UserEducation = /** @class */ (function () {
    function UserEducation() {
    }
    return UserEducation;
}());
export { UserEducation };
var ResetPassword = /** @class */ (function () {
    function ResetPassword() {
    }
    return ResetPassword;
}());
export { ResetPassword };
//# sourceMappingURL=user.js.map